import { jsx as _jsx } from "react/jsx-runtime";
import ViewToggleButton from "./index";
function ViewportViewToggleButton() {
    return (_jsx(ViewToggleButton, { baseClass: "ms3-viewport-button", additionalClasses: "ms3-viewport-button--bottom-right ms3-viewport-button--mobile-view-toggle", viewModifierClassPrefix: "ms3-viewport-button--mobile-view-toggle--" }));
}
export default ViewportViewToggleButton;
